import { Component, OnInit } from '@angular/core';

declare const window: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  static isMobileMenu(): boolean {
    if (window.innerWidth > 991) {
        return false;
    }
    return true;
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/layout/layout.component.ts